/*jslint browser: true */
/*global window:false, jQuery:false, ko:false */

;(function ($) {
    "use strict";

    var tagsEditUrl;

    var TagObject = function () {
        this.progressTags = ko.observableArray([]);
        this.progressTagsDebounced = ko.observableArray([]);
    };
    TagObject.prototype.toString = function () {
        return this.id.toString();
    };
    TagObject.prototype.preload = function () {
        $('<img/>', { src: this.src });
    };

    TagObject.prototype.editTags = function (tagIds, action) {
        var dfd = $.Deferred();
        var data = { 'id' : this.id, 'do': action, 'tag_ids': tagIds};
        var url = typeof this.edit_url != 'undefined' ? this.edit_url : tagsEditUrl;

        $.ajax({
            url:  url,
            data: data,
            type: 'POST',
            dataType: 'json',
            success: function(result){
                if (result.success) {
                    dfd.resolve();
                }
                dfd.reject(result.error || "Не удалось сохранить изменения.");
            },
            error: function(xhr){
                if (typeof(xhr.responseJSON) != 'undefined' && typeof(xhr.responseJSON.error) != 'undefined') {
                    dfd.reject(xhr.responseJSON.error);
                }
            }
        });

        return dfd.promise();
    };
    TagObject.prototype.addTag = function (tagId) {
        return this.editTags([tagId], 'add');
    };
    TagObject.prototype.removeTags = function (tagIds) {
        if (0 < this.tags.length) {
            return this.editTags(tagIds, 'delete');
        }
    };

    /**
     * @static
     * @param options
     */
    TagObject.Init = function (options) {
        if (!tagsEditUrl && options.tagsEditUrl) {
            tagsEditUrl = options.tagsEditUrl;
            $(window).trigger('scroll');
        }
    };

    window.TagObject = TagObject;
})(jQuery);